import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';


const json = {
  1: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P38-E1',
    audio: '',
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page38/E1/1.jpg' },
      ]
    ]
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P38-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page38/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page38/E2/0.jpg' },
      ],

      [
        // Column1
        { url: 'img/FriendsPlus/Page38/E2/1.jpg' },
      ],

      [
        // Column2
        { url: 'img/FriendsPlus/Page38/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page38/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page38/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page38/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/7.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page38/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page38/E2/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page38/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/11.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page38/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page38/E2/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page38/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/15.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page38/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/17.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page38/E2/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page38/E2/19.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page38/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/21.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page38/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/23.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page38/E2/24.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page38/E2/25.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page38/E2/26.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/27.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page38/E2/28.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/29.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page38/E2/30.jpg' },
      ],
      [
        // Column13
        { url: 'img/FriendsPlus/Page38/E2/31.jpg' },
      ],


    ],
  },




}

export default json;